
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1d33059a!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./merchantChannel.vue")
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1d33059a&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=1!./merchantChannel.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./merchantChannel.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1d33059a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./merchantChannel.vue"),
  /* scopeId */
  "data-v-1d33059a",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/operationManagement/merchantChannel.vue
// module id = 1523
// module chunks = 3